import { IconWhatsApp } from '@/components/Icons'
import { buildCounsellingWhatsAppUrl } from '@/lib/siteConfig'
import { useCurrentTime } from '@/lib/hydration'

export function WhatsAppButton() {
  const now = useCurrentTime()
  return (
    <aside aria-label="Floating contact">
      <a
        href={buildCounsellingWhatsAppUrl(now)}
        target="_blank"
        rel="noopener noreferrer"
        title="Chat on WhatsApp"
        aria-label="Chat on WhatsApp"
        className="fixed bottom-20 right-6 z-50 bg-[#25D366] text-white w-[52px] h-[52px] rounded-full flex items-center justify-center shadow-lg hover:scale-[1.08] transition-transform no-underline"
      >
        <IconWhatsApp size={28} />
      </a>
    </aside>
  )
}
